// extracted by mini-css-extract-plugin
module.exports = {"className":"textDisplayXL_className__yLlIS"};